<template>
  <div class="mobileNev">
    <nav>
      <div class="navigation" :class="{'visible':visible}">
        <div class="clearfix">
          <aside class="sidebar">
            <nav class="sidebar-nav">
              <ul class="metismenu" id="menu">
                <li
                  v-for="(item,index) in data"
                  :key="index"
                  :class="{'mobile-nav-active':item.mobileColor}"
                >
                  <a
                    :class="{'has-arrow':item.twoMenu,}"
                    :aria-expanded="item.mobileActive"
                    @click="Pinch(index)"
                  >{{item.name}}</a>
                  <!--  二级菜单 -->
                  <ul aria-expanded="true" class="expand-lvl2" v-show="item.mobileActive">
                    <li
                      v-for="(itemTwo,indexTwo) in item.twoMenu"
                      :key="indexTwo"
                      :class="{'mobile-nav-active':itemTwo.mobileColor}"
                    >
                      <a
                        :class="{'has-arrow':itemTwo.thrMenu}"
                        :aria-expanded="itemTwo.mobileActive"
                        @click.stop="PinchTwo(itemTwo,item.url,index,indexTwo,true)"
                      >{{itemTwo.name}}</a>
                      <!-- 三级菜单 -->
                      <ul aria-expanded="true" class="expand-lvl3" v-show="itemTwo.mobileActive">
                        <li
                          v-for="(itemThr,indexThr) in itemTwo.thrMenu"
                          :key="indexThr"
                          :class="{'mobile-nav-active':itemThr.mobileColor}"
                        >
                          <a
                            @click.stop="PinchThree(itemThr,item.url,index,indexTwo,indexThr,true)"
                          >{{itemThr.name}}</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </aside>
        </div>
      </div>
      <!--end navigation-->
    </nav>
  </div>
</template>

<script>
import MenuData from "@/fhMenu";
import devConfig from "@/devConfig";

export default {
  data() {
    return {
      twoFlag: false,
      threeFlag: false,
      data: [],
      isVueComponent: false,
      iframeUrl: "",
      currentTabComponent: "",
      uri: ""
    };
  },
  props: ["visible"],
  beforeMount() {
    devConfig.init(this, () => {
      this.data = MenuData.getMenu();
      if (this.$route.name == "home") {
        this.Pinch(0);
        return;
      }
      let one = this.$route.query.oneIndex;
      let two = this.$route.query.twoIndex;
      let thr = this.$route.query.thrMenuIndex;
      if (thr != undefined) {
        this.Pinch(one);
        this.PinchTwo(
          this.data[one].twoMenu[two],
          this.data[one].url,
          one,
          two,
          false
        );
        this.PinchThree(
          this.data[one].twoMenu[two].thrMenu[thr],
          this.data[one].url,
          one,
          two,
          thr,
          false
        );
      } else if (one != undefined && two != undefined) {
        this.Pinch(one);
        this.PinchTwo(
          this.data[one].twoMenu[two],
          this.data[one].url,
          one,
          two,
          false
        );
      }
    });
  },
  methods: {
    /* 点击一级菜单 */
    Pinch(index) {
      if (this.data[index].mobileActive == true) {
        this.data[index].mobileActive = false;
        if (this.data[index].name == "Home") {
          this.$emit("close", false);
        }
        return;
      }
      //  this.reset();
      this.clear(1);
      this.data[index].mobileActive = true;
      if (this.data[index].name == "Home") {
        this.$router.push("/home");
        this.reset();
        this.data[index].mobileColor = true;
        this.$emit("close", false);
      }
    },
    /* 点击二级菜单 */
    PinchTwo(item, name, index, indexTwo, flag) {
      if (!item.thrMenu) {
        if (name) {
          this.$router.push(
            "/" + name + "?oneIndex=" + index + "&twoIndex=" + indexTwo
          );
        }
        this.reset();
        item.mobileColor = true;
        this.$emit("close", false);
      }

      if (item.mobileActive == true) {
        item.mobileActive = false;
        return;
      }
      this.clear(2);
      item.mobileActive = true;

      if (flag) {
        this.$emit("changeNev", indexTwo);
      }
    },
    /* 点击三级菜单 */
    PinchThree(item, name, index, indexTwo, indexThr, flag) {
      if (name) {
        this.$router.push(
          "/" +
            name +
            "?oneIndex=" +
            index +
            "&twoIndex=" +
            indexTwo +
            "&thrMenuIndex=" +
            indexThr
        );
      }
      this.reset();
      item.mobileColor = true;
      this.$emit("close", false);
      if (flag) {
        this.$emit("changeNev", indexTwo, indexThr);
      }
    },
    clear(flag) {
      /* 收缩 */
      this.data.forEach(element => {
        if (flag == 1) {
          element.mobileActive = false;
          if (element.twoMenu) {
            element.twoMenu.forEach(element => {
              element.mobileActive = false;
            });
          }
        } else if (flag == 2) {
          if (element.twoMenu) {
            element.twoMenu.forEach(element => {
              element.mobileActive = false;
            });
          }
        }
      });
    },
    reset() {
      /* 颜色 */
      this.data.forEach(element => {
        element.mobileColor = false;
        if (element.twoMenu) {
          element.twoMenu.forEach(element => {
            element.mobileColor = false;
            if (element.thrMenu) {
              element.thrMenu.forEach(element => {
                element.mobileColor = false;
              });
            }
          });
        }
      });
    }
  }
};
</script>


<style src="@/assets/style/sliderNav.css"></style>
<style src="@/assets/style/metisMenu.min.css"></style>



